<ng-container *ngIf="isCart">
  <div class="spinner mx-auto my-8" *ngIf="isLoading"></div>
  <ng-container *ngIf="!isLoading">
    <div
      *ngFor="let item of items"
      class="summary"
      [class.summary__cart]="isCart"
    >
      <ng-container *ngIf="timeslotAvailable(item?.timeslot?.identifier)">
        <img
          *ngIf="isImageDisplayed"
          [src]="item.activity?.image?.url"
          alt=""
          class="summary__image"
          aria-hidden="true"
        />
        <div *ngIf="isCart" class="summary-activity-header">
          <h1 class="summary-activity-header-date">
            {{ getCartTimeslotTitle(item?.timeslot?.startDate) }}
          </h1>
          <div class="summary-activity-header-buttons">
            <button
              app-vtmn-play-icon-button
              type="button"
              class="summary-activity-header-buttons-see"
              [type]="ctaButtonType.Button"
              [size]="vtmnPlayIconButtonSize.SMALL"
              [variant]="vtmnPlayIconButtonVariant.PRIMARY"
              [style]="vtmnPlayIconButtonStyle.INVERSE"
              [attr.aria-label]="item.activity.name"
              (click)="goToActivity(item.activity)"
            >
              <vtmn-play-icon
                [name]="icon?.Eye"
                [height]="18"
                [width]="18"
              ></vtmn-play-icon>
            </button>
            <button
              app-vtmn-play-icon-button
              type="button"
              class="summary-activity-header-buttons-edit"
              [type]="ctaButtonType.Button"
              [size]="vtmnPlayIconButtonSize.SMALL"
              [variant]="vtmnPlayIconButtonVariant.PRIMARY"
              [style]="vtmnPlayIconButtonStyle.INVERSE"
              [attr.aria-label]="item.activity.name"
              (click)="editTimeslot(item.timeslot)"
            >
              <vtmn-play-icon
                [name]="icon?.Edit"
                [height]="18"
                [width]="18"
                ariaLabel="'a11y.attendee.cart.edit_timeslot.label' | translate"
              ></vtmn-play-icon>
            </button>
            <button
              app-vtmn-play-icon-button
              type="button"
              class="summary-activity-header-buttons-delete"
              [type]="ctaButtonType.Button"
              [size]="vtmnPlayIconButtonSize.SMALL"
              [variant]="vtmnPlayIconButtonVariant.PRIMARY"
              [style]="vtmnPlayIconButtonStyle.INVERSE"
              [attr.aria-label]="item.activity.name"
              (click)="deleteTimeslot(item.timeslot)"
            >
              <vtmn-play-icon
                [name]="icon?.DeleteBin"
                [height]="18"
                [width]="18"
                [ariaLabel]="
                  'a11y.attendee.cart.clear_timeslot.label' | translate
                "
              ></vtmn-play-icon>
            </button>
          </div>
        </div>

        <p class="body-bold my-1" [class.summary-activity-name__cart]="isCart">
          {{ item.activity.name }}
        </p>

        <p *ngIf="hasAddress(item)" class="mb-1 text-vtmn-play-content-quiet">
          {{ formattedAddress(item) }}
        </p>

        <time
          class="text-vtmn-play-content-quiet"
          [attr.datetime]="item.timeslot.startDate"
        >
          {{ startDateFormatted(item.timeslot.startDate) | titlecase }}
          <span
            *ngIf="isTimezoneSelectionEnabled && isLive(item.activity?.type)"
          >
            {{ item.timeslot.startDate | localizedDate: '(z)' }}
          </span>
        </time>

        <app-collapse
          *ngIf="isCart"
          [isCart]="true"
          class="flex flex-col-reverse"
          [iconName]="icon.ChevronDown"
          buttonExtraClass="justify-center w-auto pb-0 text-right text-3xl"
        >
          <app-summary-detail
            [isCart]="true"
            [items]="items"
            [item]="item"
            [isVatDisplayed]="isVatDisplayed"
            [showExternalPayment]="showExternalPayment"
            [taxes]="taxes"
          ></app-summary-detail>
        </app-collapse>
      </ng-container>
      <div
        *ngIf="!timeslotAvailable(item?.timeslot?.identifier)"
        class="spinner mx-auto my-8"
      ></div>
    </div>

    <section *ngIf="isCart" class="summary__delete-cart">
      <button
        class="summary__delete-cart__button"
        type="button"
        (click)="showConfirmCartDeletionModal()"
      >
        {{ 'checkout.cart.delete.confirm' | translate }}
      </button>

      <app-modal
        #confirmCartDeletionModal
        class="summary__delete-cart__modal"
        (modalClose)="closeConfirmCartDeletionModal()"
      >
        <span modal-header class="summary__delete-cart__modal__title">
          {{ 'checkout.cart.delete.alert.title' | translate }}
        </span>

        <div modal-content>
          <p>{{ 'checkout.cart.delete.alert.text' | translate }}</p>
        </div>
        <div modal-footer class="summary__delete-cart__modal__footer">
          <button
            class="summary__delete-cart__modal__footer__confirm"
            app-vtmn-play-button
            type="button"
            [variant]="vtmnPlayButtonVariant.SECONDARY"
            [shape]="vtmnPlayIconButtonShape.SQUARED"
            (click)="closeConfirmCartDeletionModal()"
          >
            {{ 'checkout.cart.delete.cancel' | translate }}
          </button>

          <button
            app-vtmn-play-button
            type="button"
            [variant]="vtmnPlayButtonVariant.PRIMARY"
            [shape]="vtmnPlayIconButtonShape.SQUARED"
            (click)="deleteCart()"
          >
            {{ 'checkout.cart.delete.confirm' | translate }}
          </button>
        </div>
      </app-modal>
    </section>
  </ng-container>
</ng-container>
<ng-container *ngIf="items && !isCart">
  <div class="flex flex-col mb-4 px-4 py-3 bg-vtmn-play-container-quiet">
    <div class="flex">
      <img
        [src]="items[0]?.activity?.image?.url"
        alt=""
        class="summary__image"
        aria-hidden="true"
        class="w-1/3 mr-2"
      />
      <div class="flex flex-col overflow-hidden">
        <h1 class="overflow-hidden mr-1 text-xl font-bold leading-xl">
          {{ items[0]?.activity.name }}
        </h1>
        <p
          *ngIf="hasAddress(items[0])"
          class="flex items-center mb-1 text-vtmn-play-content-quiet"
        >
          <vtmn-play-icon class="mr-2" [name]="icon.MapPin"></vtmn-play-icon>
          {{ formattedAddress(items[0]) }}
        </p>
      </div>
    </div>
    <app-divider></app-divider>
    <div class="flex flex-col">
      <span
        class="overflow-hidden whitespace-nowrap overflow-ellipsis text-xl font-bold leading-xl"
        >{{ 'checkout.payment.summary.title' | translate }}</span
      >
      <div *ngFor="let item of items; let isLast = last" [class.mb-4]="isLast">
        <time
          class="flex items-center mt-3 mb-1 font-bold"
          [attr.datetime]="item.timeslot.startDate"
        >
          <vtmn-play-icon class="mr-2" [name]="icon.Calendar"></vtmn-play-icon>
          {{
            item.timeslot.startDate
              | localizedDate: 'EEEE dd LLLL y HH:mm'
              | titlecase
          }}
          <span
            class="summary__startdate"
            *ngIf="isTimezoneSelectionEnabled && isLive(item.activity?.type)"
          >
            {{ item.timeslot.startDate | localizedDate: '(z)' }}
          </span></time
        >
        <app-summary-detail
          [isCart]="false"
          [items]="items"
          [item]="item"
          [isVatDisplayed]="isVatDisplayed"
          [showExternalPayment]="showExternalPayment"
          [taxes]="taxes"
        ></app-summary-detail>
      </div>
    </div>
    <ng-container *appIsEnabled="toggleNameEnum.PromoCode">
      <div *ngIf="usedInMultibooking && promoCode" class="summary-promocode">
        <p class="summary-promocode__discount">
          <span>
            {{ 'checkout.promocode.infos.discount' | translate }} :
            {{ promoCode.label }}
            <button
              app-vtmn-play-icon-button
              type="button"
              class="summary-promocode__discount__delete"
              [type]="ctaButtonType.Button"
              [size]="vtmnPlayIconButtonSize.SMALL"
              [variant]="vtmnPlayIconButtonVariant.SECONDARY"
              (click)="showConfirmCodeDeletionModal()"
            >
              <vtmn-play-icon
                [name]="icon?.DeleteBin"
                [ariaLabel]="
                  'a11y.attendee.cart.clear_promocode.label' | translate
                "
              ></vtmn-play-icon>
            </button>
          </span>
          <span>- {{ discountValue | displayPrice: '€' }}</span>
        </p>
      </div>
    </ng-container>
    <p class="flex justify-between text-xl font-bold leading-xl">
      <span>{{ 'checkout.payment.summary.total' | translate }}</span>
      <span>
        {{ totalPriceWithCurrency }}
      </span>
    </p>
    <em
      *ngIf="taxes && isTaxesDisplayed"
      class="text-vtmn-play-content-quiet not-italic"
    >
      {{ 'checkout.summary.table.column.duty_free' | translate }}
    </em>
  </div>

  <app-modal
    #confirmCodeDeletionModal
    class="summary-promocode__modal"
    (modalClose)="closeConfirmCodeDeletionModal()"
  >
    <span modal-header class="summary-promocode__modal__title">
      {{ 'checkout.promocode.modal.delete.title' | translate }}
    </span>

    <div modal-content>
      <p>{{ 'checkout.promocode.modal.delete.text' | translate }}</p>
    </div>
    <div modal-footer class="summary-promocode__modal__footer">
      <button
        class="summary-promocode__modal__footer__confirm"
        app-vtmn-play-button
        type="button"
        [variant]="vtmnPlayButtonVariant.SECONDARY"
        [shape]="vtmnPlayIconButtonShape.SQUARED"
        (click)="closeConfirmCodeDeletionModal()"
      >
        {{ 'checkout.promocode.modal.delete.cancel' | translate }}
      </button>

      <button
        app-vtmn-play-button
        type="button"
        [variant]="vtmnPlayButtonVariant.PRIMARY"
        [shape]="vtmnPlayIconButtonShape.SQUARED"
        (click)="deletePromoCode()"
      >
        {{ 'checkout.promocode.modal.delete.confirm' | translate }}
      </button>
    </div>
  </app-modal>
</ng-container>
